function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["arrowRef", "borderColor", "borderRadius", "className", "color", "idx", "onCloseRequest", "overlayOpacity", "p", "placement", "renderContent", "trapFocus", "hideArrow", "hideOverlay", "popoverRef", "styles", "width", "zIndex", "querySelectorPortal"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { themeGet } from '@styled-system/theme-get';
import { Box, ThemeProvider, borderRadiusAttrs } from 'pcln-design-system';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import FocusLock from 'react-focus-lock';
import styled, { ThemeConsumer } from 'styled-components';
import { borderRadius } from 'styled-system';
import PopoverArrow from '../Arrow';
import Overlay from '../Overlay';
var ESCAPE_KEY = 27;
var PopoverGuide = styled(Box).withConfig({
  displayName: "PopoverContent__PopoverGuide",
  componentId: "sc-1olhkof-0"
})(["box-sizing:border-box;max-width:", ";width:100%;z-index:", ";position:relative;"], function (_ref) {
  var width = _ref.width;
  return typeof width === 'number' ? "".concat(width, "px") : width;
}, function (_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex < 0 ? 1 : zIndex;
});
var ContentContainer = styled.section.attrs(borderRadiusAttrs).withConfig({
  displayName: "PopoverContent__ContentContainer",
  componentId: "sc-1olhkof-1"
})(["box-sizing:border-box;font-size:", "px;max-width:100%;outline:0;", ";"], themeGet('fontSizes.0'), borderRadius);
function PopoverContent(_ref3) {
  var arrowRef = _ref3.arrowRef,
    borderColor = _ref3.borderColor,
    borderRadius = _ref3.borderRadius,
    className = _ref3.className,
    color = _ref3.color,
    idx = _ref3.idx,
    onCloseRequest = _ref3.onCloseRequest,
    overlayOpacity = _ref3.overlayOpacity,
    _ref3$p = _ref3.p,
    p = _ref3$p === void 0 ? 2 : _ref3$p,
    _ref3$placement = _ref3.placement,
    placement = _ref3$placement === void 0 ? 'top' : _ref3$placement,
    renderContent = _ref3.renderContent,
    trapFocus = _ref3.trapFocus,
    hideArrow = _ref3.hideArrow,
    hideOverlay = _ref3.hideOverlay,
    popoverRef = _ref3.popoverRef,
    styles = _ref3.styles,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? 400 : _ref3$width,
    _ref3$zIndex = _ref3.zIndex,
    zIndex = _ref3$zIndex === void 0 ? 102 : _ref3$zIndex,
    _ref3$querySelectorPo = _ref3.querySelectorPortal,
    querySelectorPortal = _ref3$querySelectorPo === void 0 ? 'body' : _ref3$querySelectorPo,
    props = _objectWithoutProperties(_ref3, _excluded);
  var handleKeyUp = useCallback(function (evt) {
    if (evt.keyCode === ESCAPE_KEY) {
      evt.stopPropagation();
      evt.preventDefault();
      onCloseRequest(evt);
    }
  }, [onCloseRequest]);
  var _useState = useState('body'),
    _useState2 = _slicedToArray(_useState, 2),
    portalSelector = _useState2[0],
    setPortalSelector = _useState2[1];
  useEffect(function () {
    window.addEventListener('keyup', handleKeyUp, false);
    return function () {
      window.removeEventListener('keyup', handleKeyUp, false);
    };
  }, [handleKeyUp]);

  // Fallback when cannot find an element
  useLayoutEffect(function () {
    if (querySelectorPortal && document.querySelector(querySelectorPortal)) {
      setPortalSelector(querySelectorPortal);
    } else {
      setPortalSelector('body');
    }
  }, [querySelectorPortal]);
  var getBorderColorName = function getBorderColorName(color, borderColor) {
    var borderColorName = borderColor;
    if (!borderColor) {
      if (color) {
        borderColorName = color;
      } else {
        borderColorName = 'border';
      }
    }
    return borderColorName;
  };
  var styleProps = {
    borderColor: getBorderColorName(color, borderColor),
    borderRadius: borderRadius,
    width: width,
    zIndex: zIndex
  };
  var content = trapFocus ? /*#__PURE__*/React.createElement(FocusLock, {
    focusOptions: {
      preventScroll: true
    }
  }, renderContent({
    handleClose: onCloseRequest
  })) : renderContent({
    handleClose: onCloseRequest
  });
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopoverGuide, _extends({
    "aria-describedby": "dialog-description-".concat(idx),
    className: className,
    "data-placement": placement,
    ref: popoverRef,
    role: "dialog",
    style: styles === null || styles === void 0 ? void 0 : styles.popover,
    p: p
  }, styleProps, props), /*#__PURE__*/React.createElement(ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/React.createElement(ContentContainer, _extends({}, styleProps, {
      tabIndex: "-1",
      "data-testid": "popover-content-container"
    }), /*#__PURE__*/React.createElement(Box, {
      boxShadowSize: "overlay-md",
      borderRadius: borderRadius,
      color: color !== null && color !== void 0 ? color : 'background.lightest',
      "data-testid": "dialog-content",
      id: "popover-description-".concat(idx),
      tabIndex: "-1"
    }, content)));
  }), !hideArrow && /*#__PURE__*/React.createElement(PopoverArrow, {
    borderColor: styleProps.borderColor,
    color: color !== null && color !== void 0 ? color : 'background.lightest',
    placement: placement,
    ref: arrowRef,
    style: styles === null || styles === void 0 ? void 0 : styles.arrow
  })), !hideOverlay && /*#__PURE__*/React.createElement(Overlay, {
    handleClick: onCloseRequest,
    overlayOpacity: overlayOpacity,
    zIndex: zIndex - 1
  })),
  // Append each instance of the Popover as portal directly to the body
  document.querySelector(portalSelector));
}
PopoverContent.propTypes = _objectSpread(_objectSpread({}, borderRadius.propTypes), {}, {
  idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  // ID needs to be required for A11y purposes. We need to uniquely identify each popover on screen
  renderContent: PropTypes.func.isRequired,
  onCloseRequest: PropTypes.func.isRequired,
  contentRef: PropTypes.object,
  className: PropTypes.string,
  p: PropTypes.number,
  color: PropTypes.string,
  bg: PropTypes.string,
  borderColor: PropTypes.string,
  placement: PropTypes.string,
  zIndex: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  overlayOpacity: PropTypes.number,
  trapFocus: PropTypes.bool,
  hideArrow: PropTypes.bool,
  hideOverlay: PropTypes.bool,
  querySelectorPortal: PropTypes.string
});
export default PopoverContent;